import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { CopyButton } from './copy-button';

interface InviteLinkDialogProps {
  inviteUrl: string | null;
  onOpenChange: (open: boolean) => void;
}

/** Shown when SMTP is degraded and the backend returned a one-time manual invite link. */
export default function InviteLinkDialog({ inviteUrl, onOpenChange }: InviteLinkDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={!!inviteUrl} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('operators.inviteLink.title')}</DialogTitle>
          <DialogDescription>{t('operators.inviteLink.degradeDescription')}</DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2 rounded-md border border-border bg-muted/50 px-3 py-2">
          <code className="min-w-0 flex-1 break-all font-mono text-[12.5px] text-foreground">
            {inviteUrl}
          </code>
          {inviteUrl && (
            <CopyButton
              text={inviteUrl}
              label={t('operators.inviteLink.copy')}
              data-testid="copy-invite-url"
              className="shrink-0"
            />
          )}
        </div>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>{t('operators.inviteLink.done')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
